import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";

export const tooltip: SxProps<Theme> = {
	color: "rgba(0, 0, 0, 0.87)",
	backgroundColor: "white",
};

